// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__9aCzr","contentWrapper":"index_contentWrapper__ji8Nf","title":"index_title__2HBVk","desc":"index_desc__XQaM4"};